import Logo from '../Logo';

const SuspenseFallback = ({ message = 'Loading workspace…' }) => (
  <div className="min-h-screen bg-cream">
    <div className="min-h-screen bg-theme-dots [background-size:20px_20px] [background-position:0_0,10px_10px]">
      <div className="mx-auto flex min-h-screen w-full max-w-2xl items-center justify-center px-6 py-10">
        <div className="w-full rounded-3xl border border-cream/60 bg-white/80 p-8 shadow-card backdrop-blur">
          <div className="flex flex-col items-center text-center">
            <Logo className="h-auto" showText />

            <div className="mt-6 flex items-center justify-center gap-3">
              <span
                className="h-10 w-10 animate-spin rounded-full border-4 border-primary/20 border-t-primary"
                aria-hidden="true"
              />
              <div className="text-left">
                <p className="text-sm font-semibold text-primary">{message}</p>
                <p className="mt-1 text-xs uppercase tracking-[0.28em] text-slate-400">
                  Please wait
                </p>
              </div>
            </div>

            <div className="mt-8 w-full space-y-3">
              <div className="h-3 w-2/3 animate-pulse rounded-full bg-primary/10" />
              <div className="h-3 w-5/6 animate-pulse rounded-full bg-primary/10" />
              <div className="h-3 w-1/2 animate-pulse rounded-full bg-primary/10" />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
);

export default SuspenseFallback;


